const baseState = {
    number: 0,
    size: 20,
    totalElements: 0,
    totalPages: 0,
    userPaginationParamsSetted: false
}

const removedPaginationReducer = (state = baseState, { type, payload }) => {

    switch (type) {
    	case "SET_ALL_PAGINATION_PARAMS_FOR_REMOVED": {
			return {
				...state,
				number: payload.number,
			    size: payload.size,
			    totalElements: payload.totalElements,
			    totalPages: payload.totalPages
			}
		}

    	case "SET_PAGE_NUMBER_REMOVED": {
			return {
				...state,
				number: payload
			}
		}

		case "SET_PAGE_SIZE_REMOVED": {
			return {
				...state,
				size: payload
			}
		}

		case "SET_TOTAL_ELEMENTS_REMOVED": {
			return {
				...state,
				totalElements: payload
			}
		}

		case "SET_TOTAL_PAGES_REMOVED": {
			return {
				...state,
				totalPages: payload
			}
		}

        default:
            return state;
    }
}

export default removedPaginationReducer